// PayslipPdf.js
import React from "react";
import { Document, Page, Text, View } from "@react-pdf/renderer";
import { fonts, reportStyles } from "../report-style";
import ReportHeader from "../report-header";
import { formatIndianCurrency, getMonthInStringNotOneIndexBased } from "../../../utils/common";
// import ReportHeader from "../report-header";

fonts();

const BankDisbursmentPDFReport = ({ bankReportPDFData, organizationInfo, bankReportFullData }) => {
  return (
    <Document>
      <Page size="A4" orientation="landscape" style={reportStyles.page}>
        <View fixed>
          <ReportHeader organizationInfo={organizationInfo} />
          <View style={reportStyles.pdfHeaderTableHeadingwrapper}>
            <Text style={reportStyles.pdfHeaderTableHeading}>
            Pay Acquiescent Report of {getMonthInStringNotOneIndexBased(bankReportPDFData[0]?.month)} {bankReportPDFData[0]?.year}
            </Text>
          </View>
        </View>

        <View style={reportStyles.pdfHeaderTable}>
          <View style={reportStyles.pdfHeaderTableBx}>
            <View style={reportStyles.HeaderTableBxWrap}>
              <Text>Total Employee:</Text>
              <Text>{bankReportFullData?.additional_details?.totalEmployee ? bankReportFullData?.additional_details?.totalEmployee : "0"}</Text>
            </View>
            <View style={reportStyles.HeaderTableBxWrap}>
              <Text>Bank Transfer Employee:</Text>
              <Text>{bankReportFullData?.additional_details?.bankTransferEmployees ? bankReportFullData?.additional_details?.bankTransferEmployees : "0"}</Text>
            </View>
            <View style={reportStyles.HeaderTableBxWrap}>
              <Text>Branch Name:</Text>
              <Text>{bankReportFullData?.org_details?.bank_details?.[0].branch_name ? bankReportFullData?.org_details?.bank_details?.[0]?.branch_name : '--'}</Text>
            </View>
          </View>

          <View style={reportStyles.pdfHeaderTableBx}>
            <View style={reportStyles.HeaderTableBxWrap}>
              <Text>Total Net Pay Amount:</Text>
              <Text>{bankReportFullData?.additional_details?.totalNetPayAmount ? bankReportFullData?.additional_details?.totalNetPayAmount : "0"}</Text>
            </View>
            <View style={reportStyles.HeaderTableBxWrap}>
              <Text>Organaztion Pan:</Text>
              <Text>{bankReportFullData?.org_details?.pan ? bankReportFullData?.org_details?.pan : '--'}</Text>
            </View>
            <View style={reportStyles.HeaderTableBxWrap}>
              <Text>Account Number:</Text>
              <Text>{bankReportFullData?.org_details?.bank_details?.[0].account_no ? bankReportFullData?.org_details?.bank_details?.[0]?.account_no : '--'}</Text>
            </View>
          </View>

          <View style={reportStyles.pdfHeaderTableBx}>
            <View style={reportStyles.HeaderTableBxWrap}>
              <Text>Organaztion Tan:</Text>
              <Text>{bankReportFullData?.org_details?.tan_no ? bankReportFullData?.org_details?.tan_no : '--'}</Text>
            </View>
            <View style={reportStyles.HeaderTableBxWrap}>
              <Text>Organaztion Bank Name :</Text>
              <Text>{bankReportFullData?.org_details?.bank_details?.[0].bank_name ? bankReportFullData?.org_details?.bank_details?.[0]?.bank_name : '--'}</Text>
            </View>
            <View style={reportStyles.HeaderTableBxWrap}>
              <Text>IFSC Code:</Text>
              <Text>{bankReportFullData?.org_details?.bank_details?.[0].ifsc_no ? bankReportFullData?.org_details?.bank_details?.[0]?.ifsc_no : '--'}</Text>
            </View>
          </View>
        </View>

        <View style={reportStyles.ReportTable}>
          {/* Table Header */}
          <View style={reportStyles.ReportTh} fixed>
            <Text style={[reportStyles.ReportHeaderCell, { width: "10%", textAlign: "left", borderRight: "1px solid #ccc" }]}>
              SL NO.
            </Text>
            <Text style={[reportStyles.ReportHeaderCell, { width: "10%", textAlign: "left", borderRight: "1px solid #ccc" }]}>
              EMPLOYEE CODE
            </Text>
            <Text style={[reportStyles.ReportHeaderCell, { width: "10%", textAlign: "left", borderRight: "1px solid #ccc" }]}>
              EMPLOYEE NAME
            </Text>
            <Text style={[reportStyles.ReportHeaderCell, { width: "10%", textAlign: "left", borderRight: "1px solid #ccc" }]}>
              BANK NAME
            </Text>
            <Text style={[reportStyles.ReportHeaderCell, { width: "10%", textAlign: "left", borderRight: "1px solid #ccc" }]}>
              BRANCH NAME
            </Text>
            <Text style={[reportStyles.ReportHeaderCell, { width: "15%", textAlign: "left", borderRight: "1px solid #ccc" }]}>
              ACCOUNT NUMBER
            </Text>
            <Text style={[reportStyles.ReportHeaderCell, { width: "10%", textAlign: "left", borderRight: "1px solid #ccc" }]}>
              IFSC CODE
            </Text>
            <Text style={[reportStyles.ReportHeaderCell, { width: "15%", textAlign: "left", borderRight: "1px solid #ccc" }]}>
              PAYMENT THROUGH (NEFT/IMPS)
            </Text>
            <Text style={[reportStyles.ReportHeaderCell, { width: "10%", textAlign: "right", borderRight: "1px solid #ccc" }]}>
              NET PAY
            </Text>
            {/* <Text style={[reportStyles.ReportHeaderCell, { width: "10%", textAlign: "left", borderRight: "1px solid #ccc" }]}>
              DATE
            </Text> */}
          </View>
          {bankReportPDFData?.map((data, index) => (
            <View style={reportStyles.ReportTd} wrap={false} key={index}>
              <View style={[reportStyles.ReportTdCell, { width: "10%", borderRight: "1px solid #ccc" }]}>
                <Text>{index + 1}</Text>
              </View>
              <View style={[reportStyles.ReportTdCell, { width: "10%", textAlign: "left", borderRight: "1px solid #ccc" }]}>
                <Text>{data?.employee_code ? data?.employee_code : '--'}</Text>
              </View>
              <View style={[reportStyles.ReportTdCell, { width: "10%", borderRight: "1px solid #ccc" }]}>
                <Text>{data?.employee_name ? data?.employee_name : "--"}</Text>
              </View>
              <View style={[reportStyles.ReportTdCell, { width: "10%", textAlign: "left", borderRight: "1px solid #ccc" }]}>
                <Text>{data?.employees?.bank_name ? data?.employees?.bank_name : "--"}</Text>
              </View>
              <View style={[reportStyles.ReportTdCell, { width: "10%", textAlign: "left", borderRight: "1px solid #ccc" }]}>
                <Text>{data?.employees?.branch_name ? data?.employees?.branch_name : '--'}</Text>
              </View>
              <View style={[reportStyles.ReportTdCell, { width: "15%", textAlign: "left", borderRight: "1px solid #ccc" }]}>
                <Text>{data?.employees?.account_number ? data?.employees?.account_number : '--'}</Text>
              </View>
              <View style={[reportStyles.ReportTdCell, { width: "10%", textAlign: "left", borderRight: "1px solid #ccc" }]}>
                <Text>{data?.employees?.ifsc_code ? data?.employees?.ifsc_code : '--'}</Text>
              </View>
              <View style={[reportStyles.ReportTdCell, { width: "15%", textAlign: "left", borderRight: "1px solid #ccc" }]}>
                <Text>{data?.employees?.payment_through ? data?.employees?.payment_through : '--'}</Text>
              </View>
              <View style={[reportStyles.ReportTdCell, { width: "10%", textAlign: "right", borderRight: "1px solid #ccc" }]}>
                <Text>{data?.payable_salary ? formatIndianCurrency(data?.payable_salary.toFixed()) : '--'}</Text>
              </View>
              {/* <View style={[reportStyles.ReportTdCell, { width: "10%", textAlign: "left", borderRight: "1px solid #ccc" }]}>
            <Text>8</Text>
          </View> */}
            </View>
          ))}

          {/* <View style={reportStyles.ReportTd} wrap={false}>
            <View style={[reportStyles.ReportTdCell, { width: "10%", borderRight: "1px solid #ccc" }]}>
              <Text>1</Text>
            </View>
            <View style={[reportStyles.ReportTdCell, { width: "10%", textAlign: "left", borderRight: "1px solid #ccc" }]}>
              <Text>TSPL76</Text>
            </View>
            <View style={[reportStyles.ReportTdCell, { width: "10%", borderRight: "1px solid #ccc" }]}>
              <Text>Prity Saha</Text>
            </View>
            <View style={[reportStyles.ReportTdCell, { width: "10%", textAlign: "left", borderRight: "1px solid #ccc" }]}>
              <Text>ICICI</Text>
            </View>
            <View style={[reportStyles.ReportTdCell, { width: "10%", textAlign: "left", borderRight: "1px solid #ccc" }]}>
              <Text>Saltlake</Text>
            </View>
            <View style={[reportStyles.ReportTdCell, { width: "15%", textAlign: "left", borderRight: "1px solid #ccc" }]}>
              <Text>Ac Name</Text>
            </View>
            <View style={[reportStyles.ReportTdCell, { width: "10%", textAlign: "left", borderRight: "1px solid #ccc" }]}>
              <Text>ifsc</Text>
            </View>
            <View style={[reportStyles.ReportTdCell, { width: "15%", textAlign: "left", borderRight: "1px solid #ccc" }]}>
              <Text>payment throu</Text>
            </View>
            <View style={[reportStyles.ReportTdCell, { width: "10%", textAlign: "right", borderRight: "1px solid #ccc" }]}>
              <Text>5000</Text>
            </View>
          </View> */}

        </View>
      </Page>
    </Document>
  );
};

export default BankDisbursmentPDFReport;
